import axios from 'axios';
import router from "@/router";
import { Message } from 'element-ui';
import { applyTenantHeader } from '@/utils/tenant';
import { getHospital } from '@/services/inst.service';
import { extractTraceId, showTraceError } from '@/utils/trace-error';

let maxTime = process.env.MAX_REQ_TIME; 

// 创建请求服务（不设置 baseURL，在请求拦截器中动态设置）
const serves = axios.create({
    timeout: maxTime
})

// 设置请求发送之前的拦截器
serves.interceptors.request.use(config => {
    // 从医院信息中获取 baseURL（如果调用方已设置则跳过）
    const hospital = getHospital();
    if (!hospital) {
        // getHospital() 内部已经处理了跳转登录页的逻辑
        return Promise.reject(new Error('未获取到医院信息'));
    }
    
    if (!config.baseURL) {
        if (!hospital.hisLocalServiceUrl) {
            const errorMessage = '请求失败，当前医院未配置医保服务';
            Message.error(errorMessage);
            return Promise.reject(new Error(errorMessage));
        }
        // 动态设置 baseURL
        config.baseURL = hospital.hisLocalServiceUrl;
    }
    applyTenantHeader(config);
    return config
}, err => {Promise.reject(err)})

// 设置响应拦截器
serves.interceptors.response.use(response => { 
    if (response.status === 200 || response.status === 204) {
        return Promise.resolve(response.data)
    } else {
        // 如果请求失败，则统一处理错误
        return Promise.reject(response)
    }
}, err => {
    // 取出状态码和消息
    let message = '';
    let status = err.response && err.response.status ? err.response.status : 0;

    let msg = err.response && err.response.data && err.response.data.error ? (
        err.response.data.error.details ? err.response.data.error.details :
        err.response.data.error.message ? err.response.data.error.message :
        err.response.data.error_description ? err.response.data.error_description :
        status + '错误') : status + '错误';

    // 提取 TraceId
    let traceId = extractTraceId(err);

    // 网络错误（hisrequest 连内网，网络错误只提示不跳登录）
    const isNetworkError = !err.response || (err.message && err.message.indexOf("Network Error") != -1);

    // 判断请求时发生的错误类型，处理不同的错误
    switch (status) {
        case 400:
            message = msg ? msg : '访问失效，请重新登陆';
            break;
        case 401:
            message = '无访问权限';
            break;
        case 406:
            message = '应用未激活或已过有效期';
            router.push('/app-register');
            break;
        case 403:
            message = msg ? msg :'请求错误';
            break;
        case 415:
            message = '参数格式错误';
            break;
        case 500:
            message = '接口发生错误';
            break;
        default:
            if (isNetworkError) {
                message = '医保服务连接失败，请检查网络';
            } else {
                message = msg ? msg : `请求错误`;
            }
            break;
    }
    showTraceError(message, traceId, status);
    return Promise.reject(message)
})

export default serves